<template>
  <div class="topbar">
    <div class="topbar__wrapper">
      <div class="topbar__panel">
        <div class="form-search">
          <span class="form-search__icon">
            <i class="icon icon-zoom" />
          </span>
          <input
            id="topbar-search"
            type="text"
            class="form-input u-br"
            placeholder="Search"
            @focus="$store.dispatch('search/open')"
          >
        </div>
        <div
          v-if="false"
          class="button-group"
        >
          <button
            class="button button--circle button--s"
            @click.stop.prevent="openNotifications"
          >
            <i class="icon icon-buzz" />
            <span class="badge">2</span>
          </button>
          <button
            class="button button--circle button--s"
          >
            <i class="icon icon-cogwheel" />
          </button>
          <button
            class="button button--circle button--s"
          >
            <i class="icon icon-pin" />
          </button>
        </div>
        <a
          href=""
          class="avatar avatar--circle avatar--s"
          @click.stop.prevent="openMainDrawer"
        >
          <img
            :src="$page.props.auth.user.avatar"
          >
        </a>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import MainDrawer from '@components/drawers/MainDrawer'
import NotificationsDrawer from '@components/drawers/NotificationsDrawer'

export default {
  name: 'Topbar',
  methods: {
    openMainDrawer () {
      this.$store.dispatch('drawer/open', {
        drawer: MainDrawer,
      })
    },
    openNotifications () {
      this.$store.dispatch('drawer/open', {
        drawer: NotificationsDrawer,
      })
    },
  },
}
</script>

